import { gql } from '@apollo/client';

export const CARRIER_INVOICE_FIELDS = gql`
    fragment CarrierInvoiceFields on carrier_invoices {
        carrier_invoice_id
        client_id
        created_at
        description
        due_date
        flagged
        invoice_number
        last_modified_at
        partner_client_id
        pay_period_end
        pay_period_start
        status
        type
        week_number
        failure_at
        failure_by
        failure_reason
        revert_started_at
        netsuite_account_id
        netsuite_invoice_id
        billcom_org_id
        billcom_bill_id
        accounting_records: outbound_integrations(
            where: { transaction_type: { _in: ["NETSUITE_INVOICE", "NETSUITE_VENDOR_BILL", "BILLCOM_BILL"] } }
            order_by: { created_at: asc }
        ) {
            id
            transaction_type
            transaction_id
            account_id
            status
            error
            reverted_at
            reverted_by
            created_at
        }
    }
`;

// The revert endpoint's response shape: the invoice plus its order ids, so a dissolve empties the page's order
// tables. Mirrors INVOICE_REVERT_FIELDS in onward-functions (src/lib/integrations/graphql.js) field for field.
export const INVOICE_REVERT_FIELDS = gql`
    ${CARRIER_INVOICE_FIELDS}

    fragment InvoiceRevertFields on carrier_invoices {
        ...CarrierInvoiceFields
        shipper_orders {
            order_id
        }
        orders {
            order_id
        }
        middle_mile_carrier_orders {
            order_id
        }
        warehouse_carrier_orders {
            order_id
        }
        contractor_orders {
            order_id
        }
    }
`;
